import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Column } from 'primereact/column';

import { useAuth } from "../../../context/useAuth";
import { limitarString } from '../../../utils/formatFunctions';
import { Icon } from '@iconify/react';
import { useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Alerts from "../../Alerts";


import 'react-tooltip/dist/react-tooltip.css'

function DepoimentosList({ depoimentos, showModalDepoimentosEdit, showModalDepoimentosDelete }) {

    const navigate = useNavigate()

    const { user, loading, token, isAdmin } = useAuth()
    const [postsForUser, setPostsForUser] = useState([]);

    const [isVisible, setIsVisible] = useState(false);
    const [isTitle, setTitle] = useState('');
    const [initDescription, setDescription] = useState('');
    const [initType, setType] = useState('');





    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} de {options.totalRecords}
                </span>
            );
        }
    };



    useEffect(() => {
        if (depoimentos) {
            console.log(depoimentos)
        }
    }, [depoimentos])


    function dateToLocaleStringCustom(date) {
        const options = {
            day: 'numeric',
            month: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        return date.toLocaleString('pt-BR', options);
    }

    return (
        <>
            <div className="UsuariosList">
                <div className="card">
                    <DataTable
                        value={depoimentos}
                        paginatorClassName={"paginator"}
                        paginatorTemplate={paginatorTemplate}
                        sortField="createdAt"
                        sortOrder={-1}
                        paginator
                        rows={12}>

                        <Column field="nome"
                            header="NOME"
                            bodyClassName="title-column"
                            style={{ width: '20%' }} >
                        </Column>

                        <Column field="dt_inclusao"
                            header="DATA"
                            bodyClassName="title-column"
                            style={{ width: '15%' }} >
                        </Column>

                        <Column field="cargo"
                            header="CARGO"
                            bodyClassName="title-column"
                            style={{ width: '20%' }} >
                        </Column>

                        <Column
                            field="status"
                            header="STATUS"
                            style={{ width: '14%' }}
                            body={(rowData) => <span><i className="Ativo"></i> {dateToLocaleStringCustom(rowData.status)}</span>}
                            bodyClassName="status-column">
                        </Column>

                        <Column
                            field="Actions"
                            header=""
                            style={{ width: '22%' }}
                            bodyClassName="actions-column"
                            body={(rowData) => {
                                return (
                                    <>
                                        <button className='Btns ButtonIcon' onClick={(e) => { showModalDepoimentosDelete(rowData.id) }}> <i><Icon className="icons" icon="mdi:trash" /></i></button>
                                        <button className='Btns View' onClick={(e) => { showModalDepoimentosEdit(rowData.id) }}>Editar <i><Icon className="icons" icon="ri:add-fill" /></i></button>
                                    </>
                                );
                            }}
                        ></Column>
                    </DataTable>
                </div>
            </div>
            <ReactTooltip id="my-tooltip-1" place="bottom" content="Publicar" />
            <ReactTooltip id="my-tooltip-2" place="bottom" content="Já publicado" />

        </>
    );
}
export default DepoimentosList;